module.exports = __webpack_public_path__ + "static/media/TowerManiaTeaser.16414e96.jpg";